// src/api/authApi.ts
import type { ApiResponse } from "#/types/api";
import type {
  ChangePasswordRequest,
  LoginRequest,
  RegisterRequest,
  ResetPasswordRequest,
} from "#/types/auth";
import type { User } from "#/types/user";
import api from "./client";

export const authApi = {
  login: (data: LoginRequest): Promise<ApiResponse<User>> =>
    api.post("/auth/login", data),
  logout: (): Promise<ApiResponse<null>> => api.post("/auth/logout"),
  sendForgotPasswordOtp: (email: string): Promise<ApiResponse<string>> =>
    api.patch("/auth/forgot-password", { email }),
  changePassword: (data: ChangePasswordRequest): Promise<ApiResponse<string>> =>
    api.patch("/auth/change-password", data),
  resetPssword: (data: ResetPasswordRequest): Promise<ApiResponse<string>> =>
    api.patch("/auth/reset-password", data),
  loginWithMicrosoft: (idToken: string): Promise<ApiResponse<User>> =>
    api.post("/auth/sso/entra", { idToken }),
  loginWithGoogle: (idToken: string): Promise<ApiResponse<User>> =>
    api.post("/auth/sso/google/login", { idToken }),
  registerWithGoogle: (data: {
    idToken: string;
    companyName: string;
    website?: string;
    size?: number;
    department?: string;
    address?: string;
  }): Promise<ApiResponse<{ message: string }>> =>
    api.post("/auth/sso/google/register", data),
  linkGoogleAccount: (idToken: string): Promise<ApiResponse<{ message: string }>> =>
    api.post("/auth/sso/google/link", { idToken }),
  me: (): Promise<ApiResponse<User>> => api.get("/auth/me"),
  register: (
    data: RegisterRequest
  ): Promise<ApiResponse<{ message: string }>> =>
    api.post("/auth/register", data),
  verifyEmail: (
    token: string
  ): Promise<ApiResponse<{ message: string }>> =>
    api.get(`/auth/verify-email?token=${token}`),
};
